import React from 'react'
import { loc } from '../../../core/utils'
import * as FinalForm from "react-final-form"
import { Button, Col, Container, Row } from 'react-bootstrap'
import TextField from '../../../form/TextField'
import SelectField from './SelectField'
import useOrderSearch from './useOrderSearch'

const requiredMessage = () => loc('Required')

const OrderSearch = ({ tunnelData, searchOrders }) => {

  const { suppliers, mapSuppliersToSelect } = useOrderSearch(tunnelData)

  const onSubmit = (values) => {
    searchOrders(values)
  }

  const validate = (values) => {
    const errors = {}
    if (!values.shop) {
      errors.shop = requiredMessage()
    }
    return errors
  }

  return (
    <FinalForm.Form
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit, values }) => {
        return (
          <Container>
            <Row>
              <Col xs={12} md={6}>
                <TextField name="orderOrName" label={loc('resume_order_input_search_label')} />
              </Col>
              <Col xs={12} md={6}>
                <SelectField
                  name="shop"
                  label={loc('shop')} options={mapSuppliersToSelect(suppliers)} />

              </Col>
            </Row>
            <Row className='justify-center-row'>
              <Col xs={12} md={4}>
                <Button onClick={handleSubmit}>{loc('search')}</Button>
              </Col>
            </Row>
          </Container>
        )
    }} />
  )
}

export default OrderSearch
